import { render } from "./PairScanRfid.vue?vue&type=template&id=0615eed8&scoped=true"
import script from "./PairScanRfid.vue?vue&type=script&lang=ts"
export * from "./PairScanRfid.vue?vue&type=script&lang=ts"

import "./PairScanRfid.vue?vue&type=style&index=0&id=0615eed8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0615eed8"

export default script